var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 29.25C6.03958 29.25 5.65365 29.0943 5.34219 28.7828C5.03073 28.4714 4.875 28.0854 4.875 27.625C4.875 27.1646 5.03073 26.7786 5.34219 26.4672C5.65365 26.1557 6.03958 26 6.5 26H24.5C24.9604 26 25.3464 26.1557 25.6578 26.4672C25.9693 26.7786 26.125 27.1646 26.125 27.625C26.125 28.0854 25.9693 28.4714 25.6578 28.7828C25.3464 29.0943 24.9604 29.25 24.5 29.25H6.5ZM6.5 21.125C6.03958 21.125 5.65365 20.9693 5.34219 20.6578C5.03073 20.3464 4.875 19.9604 4.875 19.5C4.875 19.0396 5.03073 18.6536 5.34219 18.3422C5.65365 18.0307 6.03958 17.875 6.5 17.875H19.5C19.9604 17.875 20.3464 18.0307 20.6578 18.3422C20.9693 18.6536 21.125 19.0396 21.125 19.5C21.125 19.9604 20.9693 20.3464 20.6578 20.6578C20.3464 20.9693 19.9604 21.125 19.5 21.125H6.5ZM6.5 13C6.03958 13 5.65365 12.8443 5.34219 12.5328C5.03073 12.2214 4.875 11.8354 4.875 11.375C4.875 10.9146 5.03073 10.5286 5.34219 10.2172C5.65365 9.90573 6.03958 9.75 6.5 9.75H32.5C32.9604 9.75 33.3464 9.90573 33.6578 10.2172C33.9693 10.5286 34.125 10.9146 34.125 11.375C34.125 11.8354 33.9693 12.2214 33.6578 12.5328C33.3464 12.8443 32.9604 13 32.5 13H6.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.0bb6551e57c9d031c352290b2e7454bb.svg";
export { ForwardRef as ReactComponent };